import React, { useEffect } from 'react'
import BriefcaseIcon from "../assets/icon/briefcase.svg";
import LocationIcon from "../assets/icon/location.svg";
import ProfileIcon from "../assets/icon/profile.svg";
import Logo from "../assets/icon/logo.svg";
import MenuIcon from "../assets/icon/menu.svg";
import PlayButton from "../assets/icon/play-button.svg";
import { BsTextRight } from "react-icons/bs";
import { BsBuildings } from "react-icons/bs";
import IllustrationSvg from "../assets/img/illustration.svg"
import DigischoolLogo from '../assets/img/digischool_logo.png'
import TinyLogo from '../assets/img/tiny_landing_page_icon.png'
import { BsTelephoneInboundFill } from "react-icons/bs";
import { BsGoogle } from "react-icons/bs";
import { BsArrowRight } from "react-icons/bs";
import school_image from "../assets/img/school_image.png"
import { useState } from 'react';
import Modal from '../components/Modal';
import { ACTIVE_STATUS, BLOCK_CLASSES_LOCALSTORAGE_KEY, EXEMPTED_MSISDSN_FOR_VALIDATIONS, FORBIDEN_MESSAGE, INVALID_API_RESPONSE, KENYA_PHONE_NUMBER_REGEX, LOGGED_IN_USER_TOKEN_DETAILS, SCHOOLDATA_LOCALSTORAGE_KEY, SCHOOL_ACADEMIC_BLOCKS_LOCALSTORAGE_KEY, SCHOOL_ID_LOCALSTORAGE_KEY, SCHOOL_LEVELS_ARRAY, SCHOOL_NAME_LOCALSTORAGE_KEY, SCHOOL_STREAMS_LOCALSTORAGE_KEY, SCHOOL_TERM_LOCALSTORAGE_KEY, SCHOOL_YEAR_LOCALSTORAGE_KEY, USER_ID_LOCALSTORAGE_KEY, USER_ROLES, USER_ROLE_LOCALSTORAGE_KEY } from '../configs/constants';
import CustomDropdown from '../components/CustomDropdown';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../components/CustomButton';
import LoadingDialog from '../components/LoadingDialog';
import ErrorDialog from '../components/ErrorDialog';
import SuccessfulDialog from '../components/SuccessfulDialog';
import httpService from '../services/HttpService';
import { getFromLocalStorage, saveToLocalStorage } from '../services/localStorageService';
import { data } from 'autoprefixer';








function LandingPage({ onLogin }) {

    const navigate = useNavigate();
    const [isSessionExpired, setIsSessionExpired] = useState(false)
    const pageActions = ['register', 'login' , 'getResetPasswordCode']
    const [pageAction, setPageAction] = useState('');
    const [userRole, setUserRole] = useState('');
    const [userPhone, setUserPhone] = useState("");
    const [userPassword, setUserPassword] = useState("");
    const [userName, setUserName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [showError, setShowError] = useState(false);
    const [phoneNumberValid, setPhoneNumberValid] = useState(true);
    //register cosnts
    const [schoolName, setSchoolName] = useState("");
    const [email, setEmail] = useState("");
    const [adminPassword, setaAminPassword] = useState("")
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [hasRegistered, setHasRegistered] = useState(false);
    const [schoolLevels, setSchoolLevels] = useState(SCHOOL_LEVELS_ARRAY);
    const [userPhoneNumberValid, setUserPhoneNumberValid] = useState(true)
    const [loggedInUser, setLoggedInUser] = useState({});
    const [motto , setMotto] = useState('')
    const [addressDetails , setAddressDetails] = useState('')



    useEffect(() => {
        fetchInitialLoginData()
    }, [loggedInUser]);

    const generateResetCode = async () => {  
        const resetPasswordPayload = {
            'email': email
        };
        setIsLoading(true)
        setPageAction("")
        try {
          const headers = {
            'Content-Type': 'application/json',
            //'Authorization': 'Bearer ' + loggedInUser.accessToken
          };
          const response = await httpService.request('POST', 'onboarding/staffRequestResetPasswordCode', resetPasswordPayload, headers);
          console.log('Server Response:', response);
          if (response && response.header) {
            setIsLoading(false)
            if (response.header.responseCode === 200) {
             
              //show success message
              setSuccessMessage(response.header.customerMessage)
              setShowSuccessMessage(true)
    
            } else {
              setErrorMessage(response.header.customerMessage)
              setShowError(true)
            }
          } else {
            setIsLoading(false)
            setErrorMessage(INVALID_API_RESPONSE);
            setShowError(true)
          }
    
    
        } catch (error) {
          setIsLoading(false)
          // Handle errors here
          console.error('Exception:' + error)
          if (error.response) {
            const statusCode = error.response.status;
            console.log('sttausCode inside exception:', statusCode)
            if (statusCode === 403) {
              setShowError(true)
              setErrorMessage(FORBIDEN_MESSAGE);
            } else if (statusCode === 401) {
                if(!isSessionExpired){
                    setIsSessionExpired(true)
                  }
            } else {
              setShowError(true)
              setErrorMessage(INVALID_API_RESPONSE);
            }
          } else {
            setShowError(true)
            setErrorMessage(INVALID_API_RESPONSE);
          }
        }
      };


    const handlePhoneNumberInputChange = (e) => {

        const value = e.target.value;

        setUserPhone(value);
        console.log('hello, im checking entered phone no:' + value)

        if(EXEMPTED_MSISDSN_FOR_VALIDATIONS.includes(value)){

            setPhoneNumberValid(true);

        }else{
            // Define your regex pattern
        const regexPattern = KENYA_PHONE_NUMBER_REGEX;

        const isValidInput = regexPattern.test(value);

        setPhoneNumberValid(isValidInput);
        }
    };
    const openRegisterPage = () => {
        navigate('/register')
    }
    function toggleSchoolLevels(academicBlockId, selected) {
        setSchoolLevels(currentSchoolLevels => {
            return currentSchoolLevels.map(schoolLevel => {
                if (schoolLevel.academicBlockId === academicBlockId) {
                    return { ...schoolLevel, selected, status: selected ? "Active" : "Inactive" };
                }

                return schoolLevel;
            });
        });
    }

    const processLoginAndAccessToken = async () => {

        if (userPhone.length == 0) {
            setPageAction('');
            setErrorMessage('Please enter your phone number')
            setShowError(true)
            return;
        }
        if (userPassword.length == 0) {
            setPageAction('');
            setErrorMessage('Please enter your password')
            setShowError(true)
            return;
        }
        if (!phoneNumberValid) {
            setPageAction('');
            setErrorMessage('Invalid phone number')
            setShowError(true)
            return;
        }

        try {
            setPageAction('')
            setIsLoading(true)
            const payLoad = {
                "username": userPhone,
                "password": userPassword
            };

            const response = await httpService.request('POST', 'auth/schoolStaffLogin', payLoad);
            setIsLoading(false)
            console.log('Server Response:', response);
            if (response && response.header) {
                if (response.header.responseCode === 200) {
                    saveToLocalStorage(LOGGED_IN_USER_TOKEN_DETAILS, response.body)
                    setLoggedInUser(response.body)
                }

                else {
                    setErrorMessage(response.header.customerMessage)
                    setShowError(true)
                }
            } else {
                setPageAction('')
                setErrorMessage(INVALID_API_RESPONSE);
                setShowError(true)
            }


        } catch (error) {
            setPageAction('')
            setIsLoading(false)
            // Handle errors here
            console.error('Exception:' + error)
            setErrorMessage(INVALID_API_RESPONSE);
            setShowError(true)
        }
    };


    const fetchInitialLoginData = async () => {
        setIsLoading(true)
        try {

            const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + loggedInUser.accessToken
            };
            const response = await httpService.request('GET', 'onboarding/getSchoolLoginInitialData', null, headers);
            setIsLoading(false)
            console.log('Server Response:', response);
            console.log('sttausCode', response.status)
            if (response && response.header) {
                setPageAction('');
                if (response.header.responseCode === 200) {
                    saveToLocalStorage(SCHOOL_ACADEMIC_BLOCKS_LOCALSTORAGE_KEY, response.body.academicBlocks)
                    saveToLocalStorage(BLOCK_CLASSES_LOCALSTORAGE_KEY, response.body.blockClasses)
                    saveToLocalStorage(SCHOOL_STREAMS_LOCALSTORAGE_KEY, response.body.schoolStreams)
                    saveToLocalStorage(USER_ID_LOCALSTORAGE_KEY, response.body.teacherId)
                    saveToLocalStorage(SCHOOL_ID_LOCALSTORAGE_KEY, response.body.schoolId)
                    saveToLocalStorage(SCHOOL_NAME_LOCALSTORAGE_KEY, response.body.schoolName)
                    saveToLocalStorage(SCHOOL_TERM_LOCALSTORAGE_KEY, response.body.schoolTerm)
                    saveToLocalStorage(SCHOOL_YEAR_LOCALSTORAGE_KEY, response.body.schoolYear)
                    saveToLocalStorage(USER_ROLE_LOCALSTORAGE_KEY, response.body.role)
                    saveToLocalStorage(SCHOOLDATA_LOCALSTORAGE_KEY, response.body.school)
                    onLogin();
                    navigate('/home')


                } else {
                    setErrorMessage(response.header.customerMessage)
                    setShowError(true)
                }
            } else {
                setPageAction('')
                setErrorMessage(INVALID_API_RESPONSE);
                setShowError(true)
            }


        } catch (error) {
            console.error('Exception: -> ' + error)
            //console.log('sttausCode inside exception', response.status)
            setIsLoading(false)
            if (error.response) {
                const statusCode = error.response.status;
                console.log('sttausCode inside exception:', statusCode)
                if (statusCode === 403) {
                    //setErrorMessage('Forbidden');
                    console.log('Forbidden: bearer token not passed')
                } else if (statusCode === 401) {
                    //setErrorMessage('Unauthhorized');
                    console.log('Unauthorized: use a valid token')
                } else {
                    setShowError(true)
                    setErrorMessage(INVALID_API_RESPONSE);
                }
            } else {
                setShowError(true)
                setErrorMessage(INVALID_API_RESPONSE);
            }
        }

    }

    // const processLogin = async () => {
    //     if (userRole.length == 0) {
    //         setPageAction('');
    //         setErrorMessage('Please select your role')
    //         setShowError(true)
    //         return;
    //     }
    //     if (userPhone.length == 0) {
    //         setPageAction('');
    //         setErrorMessage('Please enter your phone number')
    //         setShowError(true)
    //         return;
    //     }
    //     if (userPassword.length == 0) {
    //         setPageAction('');
    //         setErrorMessage('Please enter your password')
    //         setShowError(true)
    //         return;
    //     }
    //     if (!phoneNumberValid) {
    //         setPageAction('');
    //         setErrorMessage('Invalid phone number')
    //         setShowError(true)
    //         return;
    //     }
    //     try {
    //         const data = {
    //             "email": "",
    //             "phoneNumber": userPhone,
    //             "password": userPassword,
    //             "role": userRole
    //         };


    //         const response = await httpService.request('POST', 'onboarding/login', data);
    //         console.log('Server Response:', response);
    //         if (response && response.header) {
    //             setPageAction('');
    //             if (response.header.responseCode === 200) {


    //                 saveToLocalStorage(SCHOOL_ACADEMIC_BLOCKS_LOCALSTORAGE_KEY, response.body.academicBlocks)
    //                 saveToLocalStorage(BLOCK_CLASSES_LOCALSTORAGE_KEY, response.body.blockClasses)
    //                 saveToLocalStorage(SCHOOL_STREAMS_LOCALSTORAGE_KEY, response.body.schoolStreams)
    //                 saveToLocalStorage(USER_ID_LOCALSTORAGE_KEY, response.body.teacherId)
    //                 saveToLocalStorage(SCHOOL_ID_LOCALSTORAGE_KEY, response.body.schoolId)
    //                 saveToLocalStorage(SCHOOL_NAME_LOCALSTORAGE_KEY, response.body.schoolName)
    //                 saveToLocalStorage(SCHOOL_TERM_LOCALSTORAGE_KEY, response.body.schoolTerm)
    //                 saveToLocalStorage(SCHOOL_YEAR_LOCALSTORAGE_KEY, response.body.schoolYear)
    //                 saveToLocalStorage(USER_ROLE_LOCALSTORAGE_KEY, response.body.role)
    //                 saveToLocalStorage(SCHOOLDATA_LOCALSTORAGE_KEY, response.body.school)
    //                 onLogin();
    //                 navigate('/home')


    //             } else {
    //                 setErrorMessage(response.header.customerMessage)
    //                 setShowError(true)
    //             }
    //         } else {
    //             setPageAction('')
    //             setErrorMessage(INVALID_API_RESPONSE);
    //             setShowError(true)
    //         }


    //     } catch (error) {
    //         setPageAction('')
    //         // Handle errors here
    //         console.error('Exception:' + error)
    //         setErrorMessage(INVALID_API_RESPONSE);
    //         setShowError(true)
    //     }
    // };

    const registerSchool = async () => {
        //schoolName,email,userPhone,adminPassword

        if (schoolName.length == 0) {
            setPageAction('');
            setErrorMessage('Please enter school name')
            setShowError(true)
            return;
        }
        if (email.length == 0) {
            setPageAction('');
            setErrorMessage('Please enter school official email')
            setShowError(true)
            return;
        }


        if (userPhone.length == 0) {
            setPageAction('');
            setErrorMessage('Please enter your phone number')
            setShowError(true)
            return;
        }
        if (!KENYA_PHONE_NUMBER_REGEX.test(userPhone)) {
            setPageAction('');
            setErrorMessage('Enter a valid phone number')
            setShowError(true)
            return;
        }
        if (adminPassword.length == 0) {
            setPageAction('');
            setErrorMessage('Please enter school\'s admin password')
            setShowError(true)
            return;
        }

        if (motto.length == 0) {
            setPageAction('');
            setErrorMessage('Please enter school\'s motto ')
            setShowError(true)
            return;
        }

        setPageAction('')
        setIsLoading(true)
        try {
            const data = {
                "schoolName": schoolName,
                "email": email,
                "phoneNumber": userPhone,
                "adminPassword": adminPassword,
                "logo": "",
                "motto": motto,
                "addressDetails": addressDetails,
                "schoolTerm": 0,
                "schoolYear": 0,
                "status": ACTIVE_STATUS,
                "academicBlocks": schoolLevels
            };

            const response = await httpService.request('POST', 'onboarding/registerSchool', data);

            if (response && response.header) {
                setIsLoading(false)
                setPageAction('')
                if (response.header.responseCode === 200) {

                    setShowSuccessMessage(true);
                    setHasRegistered(true)
                    setSuccessMessage("Successfull registered! ")

                } else {
                    setErrorMessage(response.header.customerMessage)
                    setShowError(true)
                }
            } else {
                setPageAction('')
                setIsLoading(false)
                setErrorMessage(INVALID_API_RESPONSE);
                setShowError(true)
            }



            console.log('Server Response:', response);
        } catch (error) {
            setPageAction('')
            // Handle errors here
            console.error('Register School Error:', error);
            setIsLoading(false)
            // Handle errors here
            console.error('Exception:' + error)
            setErrorMessage(INVALID_API_RESPONSE);
            setShowError(true)
        }
    };








    // Get the current year
    const currentYear = new Date().getFullYear();
    const menu = ["Home", "About us", "Blogs", "Contact"];
    const features = [
        {
            icon: <BsBuildings />,
            title: "Exams",
            description:
                "Generate and manage students performances ",
            color: "bg-orange",
        },
        {
            icon: <BsBuildings />,
            title: "School Finance",
            description:
                "Receive paymannts and manage school fees conveniently",
            color: "bg-blue",
        },
        {
            icon: <BsBuildings />,
            title: "BulkSms",
            description:
                "Send students performances and other messages to parents via sms.",
            color: "bg-pink",
        },
        {
            icon: <BsBuildings />,
            title: "PocketMoney",
            description:
                "Students pocket money management system.",
            color: "bg-pink",
        },
        {
            icon: <BsBuildings />,
            title: "TimeTable",
            description:
                "School time table software also available",
            color: "bg-pink",
        }
    ];

    return (

        <div className="w-full min-h-screen font-sans text-gray-900">
            <LoadingDialog message={'Processing'} isOpen={isLoading} />
            <ErrorDialog message={errorMessage} isOpen={showError} onClose={() => setShowError(false)} />
            <SuccessfulDialog message={successMessage} isOpen={showSuccessMessage} onClose={() => setShowSuccessMessage(false)} />
            <Modal isVisible={pageAction === pageActions[0]} onClose={() => setPageAction('')}>
                <div className='flex flex-col p-3'>
                    <p className='text-lg border-b-2 mb-2 p-2'>Register</p>
                    <div className='flex flex-row space-x-2'>
                        <div className=" w-1/2 flex flex-col  py-2 mt-1">
                            <label className='text-xs text-black'>School Name</label>
                            <input
                                value={schoolName}
                                onChange={(e) => setSchoolName(e.target.value)}
                                id="schoolName"
                                className="rounded-lg text-xs text-white bg-gray-400 mt-2 p-4 focus:border-blue-500 focus:bg-gray-500 focus:outline-none"
                                type={"text"}
                            ></input>
                        </div>
                        <div className=" w-1/2 flex flex-col py-2 mt-1">
                            <label className='text-xs text-black'>School Email</label>
                            <input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                id="email"
                                className="rounded-lg text-xs text-white bg-gray-400 mt-2 p-4 focus:border-blue-500 focus:bg-gray-500 focus:outline-none"
                                type={"email"}
                            ></input>
                        </div>
                    </div>

                    <div className='flex flex-row space-x-2 mt-1'>
                        <div className=" w-1/2 flex flex-col">
                            <label className='text-xs text-black'>School Motto</label>
                            <input
                            value={motto}
                            onChange={(e) => setMotto(e.target.value)}
                            id="motto"
                            className="rounded-lg text-xs text-white bg-gray-400 mt-2 p-4 focus:border-blue-500 focus:bg-gray-500 focus:outline-none"
                            type={"text"}
                        ></input>
                        </div>
                        <div className=" w-1/2 flex flex-col">
                            <label className='text-xs text-black'>School Address</label>
                            <input
                                value={addressDetails}
                                onChange={(e) => setAddressDetails(e.target.value)}
                                id="addressDetails"
                                className="rounded-lg text-xs text-white bg-gray-400 mt-2 p-4 focus:border-blue-500 focus:bg-gray-500 focus:outline-none"
                                type={"text"}
                            ></input>
                        </div>
                    </div>

                    <div className='flex flex-row space-x-2 mt-1'>
                        <div className=" w-1/2 flex flex-col">
                            <label className='text-xs text-black'>School Phone Number</label>
                            <input
                                value={userPhone}
                                onChange={(e) => {
                                    setUserPhone(e.target.value)
                                }}
                                id="phone"
                                className="rounded-lg text-xs text-white bg-gray-400 mt-2 p-4 focus:border-blue-500 focus:bg-gray-500 focus:outline-none"
                                type={"phone"}
                            ></input>
                            <p className={`text-xs text-red-500 ${KENYA_PHONE_NUMBER_REGEX.test(userPhone) ? 'fade-out' : 'fade-in'}`}>Invalid phone number</p>
                        </div>
                        <div className=" w-1/2 flex flex-col">
                            <label className='text-xs text-black'>School Admin Password</label>
                            <input
                                value={adminPassword}
                                onChange={(e) => setaAminPassword(e.target.value)}
                                id="adminPassword"
                                className="rounded-lg text-xs text-white bg-gray-400 mt-2 p-4 focus:border-blue-500 focus:bg-gray-500 focus:outline-none"
                                type={"password"}
                            ></input>
                        </div>
                    </div>
                    
                   
                    <div className=' mt-6'>
                        <p className='text-black  text-xs '>Modules</p>
                        <div className=' grid grid-cols-2 md:grid-cols-3 gap-2 mt-2'>
                            {schoolLevels.map((schoolLevel, index) =>
                                <div onClick={() => toggleSchoolLevels(schoolLevel.academicBlockId, !schoolLevel.selected)} className='flex flex-col py-1 md:py-2 border rounded-lg  shadow-md bg-slate-50 hover:bg-slate-400 cursor-pointer'>
                                    <div className='w-full flex flex-row justify-end'>
                                        <div className="flex items-center">
                                            <input onChange={e => toggleSchoolLevels(schoolLevel.academicBlockId, e.target.checked)} type="checkbox" id="myCheckbox" className="form-checkbox text-blue-500 h-2 w-2 md:h-3 md:w-3 rounded-full mr-2" checked={schoolLevel.selected} />
                                        </div>
                                    </div>
                                    <p className=" text-xs p-1 md:p-2">{schoolLevel.blockName}</p>
                                </div>
                            )}
                        </div>
                    </div>
                    <CustomButton
                        buttonStyle={
                            "w-full my-1 py-4 mt-5 bg-blue-400 shadow-lg shadow-teal-500/50 hover:shadow-teal-500/40 rounded-lg text-white text-xs"
                        }
                        buttonText={"Register"}
                        onClick={() => { registerSchool() }}
                    />
                    <div className='flex flex-col items-center mt-4 mb-7'>
                        <p className='text-xs text-gray-500'>Already registered? <span onClick={() => { setPageAction(pageActions[1]) }} className=' text-blue-800 cursor-pointer'>Login now</span></p>
                    </div>
                </div>
            </Modal>
            <Modal isVisible={pageAction === pageActions[2]} onClose={() => setPageAction('')}>
            <div className='flex flex-col p-4'>
                    <p className=' text-lg border-b-2 mb-2 p-2'>Reset Password</p>
                    <div className=" w-full flex flex-col py-2 mt-1">
                            <label className='text-xs text-black'>Enter your email</label>
                            <input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                id="email"
                                className="rounded-lg text-xs text-white bg-gray-400 mt-2 p-4 focus:border-blue-500 focus:bg-gray-500 focus:outline-none"
                                type={"email"}
                            ></input>
                        </div>
                        <CustomButton
                        buttonStyle={
                            "w-full my-1 py-4 mt-5 bg-blue-400 shadow-lg shadow-teal-500/50 hover:shadow-teal-500/40 rounded-lg text-white text-xs"
                        }
                        buttonText={"Generate Reset Password Link"}
                        onClick={() => { 
                            if(email.length===0){
                                setPageAction("")
                                setErrorMessage("Email cant be empty")
                                setShowError(true)


                            }else{

                                generateResetCode()
                            
                            }
                           
                        }}
                    />
                    </div>

            </Modal>
            <Modal isVisible={pageAction === pageActions[1]} onClose={() => setPageAction('')}>
                <div className='flex flex-col p-4'>
                    <p className=' text-lg border-b-2 mb-2 p-2'>Login</p>
                    {/* <div className=" w-full flex flex-col text-gray-400 mt-2">
                        <p className="text-black text-xs">Select your role</p>
                        <CustomDropdown options={USER_ROLES} style={'w-full'} onOptionSelect={setUserRole} />
                    </div> */}
                    <div className='grid grid-cols-1 md:grid-cols-2 mt-2 gap-1 md:gap-2'>
                        <div className="flex flex-col py-2 ">
                            <label className=" text-black text-xs">Phone number</label>
                            <input
                                value={userPhone}
                                onChange={handlePhoneNumberInputChange}
                                id="phone"
                                className={` border-red-500 text-xs rounded-lg bg-gray-400 mt-2 p-4 text-white focus:border-blue-500 focus:bg-gray-500 focus:outline-none`}
                                type={"phone"}
                            ></input>
                            <p className={`text-xs text-red-500 ${phoneNumberValid ? 'fade-out' : 'fade-in'}`}>Invalid phone number</p>
                        </div>
                        <div className="flex flex-col py-2">
                            <label className="text-black text-xs">Password</label>
                            <input
                                value={userPassword}
                                onChange={(e) => setUserPassword(e.target.value)}
                                id="password"
                                className="rounded-lg text-xs bg-gray-400 mt-2 p-4 text-white focus:border-blue-500 focus:bg-gray-500 focus:outline-none"
                                type={"password"}
                            ></input>
                        </div>
                    </div>
                    <div className='flex flex-row items-center justify-end w-full'>
                        <p 
                        onClick={()=>{
                            setPageAction(pageActions[2])
                        }}
                        className=' text-blue-800 text-xs font-semibold cursor-pointer'>Forgot password?</p>
                    </div>
                    <CustomButton
                        // bg-gradient-to-b from-[#FEE6F7] to-[#f8aee2]
                        buttonStyle={
                            "w-full my-5 py-4 bg-blue-400 shadow-lg shadow-teal-500/50 hover:shadow-teal-500/40 rounded-lg text-white text-xs"
                        }
                        buttonText={"Login"}
                        onClick={() => {
                            processLoginAndAccessToken()
                        }}
                    />
                    <div className='flex flex-col items-center mb-7'>
                        <p className='text-xs text-gray-500'>Not registered yet? <span onClick={() => { setPageAction(pageActions[0]) }} className=' text-blue-800 cursor-pointer'>Create account</span></p>
                    </div>
                </div>
            </Modal>
            <div className="bg-gradient-to-b from-[#7e93f0] to-white">
                {/* <img
                    src="assets/img/blob.svg"
                    alt=""
                    className="absolute top-0 right-0 pointer-events-none"
                /> */}

                <div className="px-6 mx-auto max-w-6xl">
                    <div className="flex justify-between items-center py-10">
                        {/* <p>DigiSchool</p> */}
                        {/* <svg width="175" height="36" viewBox="0 0 175 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="46" cy="20" r="5" fill="#FFBE21" />
                            <circle cx="64" cy="20" r="5" fill="#FFBE21" />
                            <path d="M1.904 28V8.4H5.488V16.548H14.28V8.4H17.864V28H14.28V19.46H5.488V28H1.904ZM26.3775 28.336C25.1829 28.336 24.2029 28.1493 23.4375 27.776C22.6722 27.384 22.1029 26.8707 21.7295 26.236C21.3562 25.6013 21.1695 24.9013 21.1695 24.136C21.1695 22.848 21.6735 21.8027 22.6815 21C23.6895 20.1973 25.2015 19.796 27.2175 19.796H30.7455V19.46C30.7455 18.508 30.4749 17.808 29.9335 17.36C29.3922 16.912 28.7202 16.688 27.9175 16.688C27.1895 16.688 26.5549 16.8653 26.0135 17.22C25.4722 17.556 25.1362 18.06 25.0055 18.732H21.5055C21.5989 17.724 21.9349 16.8467 22.5135 16.1C23.1109 15.3533 23.8762 14.784 24.8095 14.392C25.7429 13.9813 26.7882 13.776 27.9455 13.776C29.9242 13.776 31.4829 14.2707 32.6215 15.26C33.7602 16.2493 34.3295 17.6493 34.3295 19.46V28H31.2775L30.9415 25.76C30.5309 26.5067 29.9522 27.1227 29.2055 27.608C28.4775 28.0933 27.5349 28.336 26.3775 28.336ZM27.1895 25.536C28.2162 25.536 29.0095 25.2 29.5695 24.528C30.1482 23.856 30.5122 23.0253 30.6615 22.036H27.6095C26.6575 22.036 25.9762 22.2133 25.5655 22.568C25.1549 22.904 24.9495 23.324 24.9495 23.828C24.9495 24.3693 25.1549 24.7893 25.5655 25.088C25.9762 25.3867 26.5175 25.536 27.1895 25.536ZM37.7497 34.16V14.112H40.9417L41.3337 16.1C41.7817 15.484 42.3697 14.9427 43.0977 14.476C43.8444 14.0093 44.8057 13.776 45.9817 13.776C47.2884 13.776 48.455 14.0933 49.4817 14.728C50.5084 15.3627 51.3204 16.2307 51.9177 17.332C52.515 18.4333 52.8137 19.684 52.8137 21.084C52.8137 22.484 52.515 23.7347 51.9177 24.836C51.3204 25.9187 50.5084 26.7773 49.4817 27.412C48.455 28.028 47.2884 28.336 45.9817 28.336C44.9364 28.336 44.0217 28.14 43.2377 27.748C42.4537 27.356 41.819 26.8053 41.3337 26.096V34.16H37.7497ZM45.2257 25.2C46.3644 25.2 47.307 24.8173 48.0537 24.052C48.8004 23.2867 49.1737 22.2973 49.1737 21.084C49.1737 19.8707 48.8004 18.872 48.0537 18.088C47.307 17.304 46.3644 16.912 45.2257 16.912C44.0684 16.912 43.1164 17.304 42.3697 18.088C41.6417 18.8533 41.2777 19.8427 41.2777 21.056C41.2777 22.2693 41.6417 23.268 42.3697 24.052C43.1164 24.8173 44.0684 25.2 45.2257 25.2ZM56.0153 34.16V14.112H59.2073L59.5993 16.1C60.0473 15.484 60.6353 14.9427 61.3633 14.476C62.11 14.0093 63.0713 13.776 64.2473 13.776C65.554 13.776 66.7206 14.0933 67.7473 14.728C68.774 15.3627 69.586 16.2307 70.1833 17.332C70.7806 18.4333 71.0793 19.684 71.0793 21.084C71.0793 22.484 70.7806 23.7347 70.1833 24.836C69.586 25.9187 68.774 26.7773 67.7473 27.412C66.7206 28.028 65.554 28.336 64.2473 28.336C63.202 28.336 62.2873 28.14 61.5033 27.748C60.7193 27.356 60.0846 26.8053 59.5993 26.096V34.16H56.0153ZM63.4913 25.2C64.63 25.2 65.5726 24.8173 66.3193 24.052C67.066 23.2867 67.4393 22.2973 67.4393 21.084C67.4393 19.8707 67.066 18.872 66.3193 18.088C65.5726 17.304 64.63 16.912 63.4913 16.912C62.334 16.912 61.382 17.304 60.6353 18.088C59.9073 18.8533 59.5433 19.8427 59.5433 21.056C59.5433 22.2693 59.9073 23.268 60.6353 24.052C61.382 24.8173 62.334 25.2 63.4913 25.2ZM74.7591 34.16L77.9791 27.076H77.1391L71.7351 14.112H75.6271L79.5191 23.884L83.5791 14.112H87.3871L78.5671 34.16H74.7591ZM96.486 28V8.4H100.07V16.548H108.862V8.4H112.446V28H108.862V19.46H100.07V28H96.486ZM122.836 28.336C121.492 28.336 120.278 28.028 119.196 27.412C118.132 26.796 117.282 25.9467 116.648 24.864C116.032 23.7627 115.724 22.4933 115.724 21.056C115.724 19.6187 116.041 18.3587 116.676 17.276C117.31 16.1747 118.16 15.316 119.224 14.7C120.306 14.084 121.52 13.776 122.864 13.776C124.189 13.776 125.384 14.084 126.448 14.7C127.53 15.316 128.38 16.1747 128.996 17.276C129.63 18.3587 129.948 19.6187 129.948 21.056C129.948 22.4933 129.63 23.7627 128.996 24.864C128.38 25.9467 127.53 26.796 126.448 27.412C125.365 28.028 124.161 28.336 122.836 28.336ZM122.836 25.228C123.769 25.228 124.581 24.8827 125.272 24.192C125.962 23.4827 126.308 22.4373 126.308 21.056C126.308 19.6747 125.962 18.6387 125.272 17.948C124.581 17.2387 123.778 16.884 122.864 16.884C121.912 16.884 121.09 17.2387 120.4 17.948C119.728 18.6387 119.392 19.6747 119.392 21.056C119.392 22.4373 119.728 23.4827 120.4 24.192C121.09 24.8827 121.902 25.228 122.836 25.228ZM133.152 28V14.112H136.316L136.624 15.988C137.072 15.316 137.66 14.784 138.388 14.392C139.135 13.9813 139.993 13.776 140.964 13.776C143.111 13.776 144.632 14.6067 145.528 16.268C146.032 15.5027 146.704 14.896 147.544 14.448C148.403 14 149.336 13.776 150.344 13.776C152.155 13.776 153.545 14.3173 154.516 15.4C155.487 16.4827 155.972 18.0693 155.972 20.16V28H152.388V20.496C152.388 19.3013 152.155 18.3867 151.688 17.752C151.24 17.1173 150.54 16.8 149.588 16.8C148.617 16.8 147.833 17.1547 147.236 17.864C146.657 18.5733 146.368 19.5627 146.368 20.832V28H142.784V20.496C142.784 19.3013 142.551 18.3867 142.084 17.752C141.617 17.1173 140.899 16.8 139.928 16.8C138.976 16.8 138.201 17.1547 137.604 17.864C137.025 18.5733 136.736 19.5627 136.736 20.832V28H133.152ZM166.123 28.336C164.723 28.336 163.481 28.0373 162.399 27.44C161.316 26.8427 160.467 26.0027 159.851 24.92C159.235 23.8373 158.927 22.5867 158.927 21.168C158.927 19.7307 159.225 18.452 159.823 17.332C160.439 16.212 161.279 15.344 162.343 14.728C163.425 14.0933 164.695 13.776 166.151 13.776C167.513 13.776 168.717 14.0747 169.763 14.672C170.808 15.2693 171.62 16.0907 172.199 17.136C172.796 18.1627 173.095 19.3107 173.095 20.58C173.095 20.7853 173.085 21 173.067 21.224C173.067 21.448 173.057 21.6813 173.039 21.924H162.483C162.557 23.0067 162.931 23.856 163.603 24.472C164.293 25.088 165.124 25.396 166.095 25.396C166.823 25.396 167.429 25.2373 167.915 24.92C168.419 24.584 168.792 24.1547 169.035 23.632H172.675C172.413 24.5093 171.975 25.312 171.359 26.04C170.761 26.7493 170.015 27.3093 169.119 27.72C168.241 28.1307 167.243 28.336 166.123 28.336ZM166.151 16.688C165.273 16.688 164.499 16.94 163.827 17.444C163.155 17.9293 162.725 18.676 162.539 19.684H169.455C169.399 18.7693 169.063 18.0413 168.447 17.5C167.831 16.9587 167.065 16.688 166.151 16.688Z" fill="black" />
                        </svg> */}
                        <img src={TinyLogo} alt="" />
                        <nav className="hidden md:flex md:items-center md:space-x-10">
                            {/* <a href="#" className="text-gray-700 hover:text-gray-900">
                                Prici
                            </a> */}
                            <a onClick={() => setPageAction(pageActions[0])} href="#" className="font-semibold text-indigo-600 hover:text-indigo-800 border-red-700 border-2 shadow-sm m-6 p-3 rounded-lg flex flex-row items-center space-x-3">
                                <span>Get Started</span>
                                <BsArrowRight />
                            </a>
                        </nav>
                        <button className="p-4 md:hidden">
                            <BsTextRight className="w-6 h-6 text-gray-800" />
                        </button>
                    </div>
                </div>


                <div className="px-6 mx-auto max-w-6xl">
                    <div className="flex flex-col-reverse items-center md:flex-row lg:items-end">
                        <div className="pt-24 pr-8 pb-24 text-center md:pb-12 md:w-1/2 md:text-left">
                            <h1 className="relative z-10 text-5xl font-bold md:text-6xl font-display">
                                DigiSchool.App
                                <span
                                    className="relative after:content-[url(assets/img/scratch.svg)] after:absolute after:-top-2 after:-right-6 after:-z-1"
                                >
                                    
                                </span>
                                Your CBC

                                <span className="relative after:content-[url('assets/img/decoration.svg')] after:absolute after:-bottom-2 after:-right-8 after:-z-1">
                                    partner
                                </span>

                            </h1>
                            <p className="pt-8 text-lg leading-relaxed text-gray-500 md:max-w-md md:text-xl">
                            One stop shop for all your school ICT needs i.e Result Analysis Management System, Fees Management System, School Bulk Sms System, School Timetable System and Cashless Pocket Money Management System among others.
                            </p>
                            <div
                                className="flex justify-center items-center pt-12 space-x-6 md:justify-start"
                            >
                                <button
                                    onClick={() => setPageAction(pageActions[0])}
                                    className="flex justify-center items-center py-4 px-8 font-bold tracking-wide leading-7 text-white bg-blue-600 rounded-xl hover:shadow-xl"
                                >
                                    Register
                                </button>
                                <button
                                    onClick={() => setPageAction(pageActions[1])}
                                    className="flex justify-center items-center py-4 px-8 font-bold tracking-wide leading-7 text-white bg-blue-600 rounded-xl hover:shadow-xl">
                                    Login
                                </button>
                                <button
                                    onClick={() => window.open("https://finance.digischool.app", "_blank", "noopener,noreferrer")}
                                    className="flex justify-center items-center py-4 px-8 font-bold tracking-wide leading-7 text-white bg-blue-600 rounded-xl hover:shadow-xl"
                                    >
                                    Finance
                                </button>
                            </div>
                        </div>
                        <div className="flex items-end w-1/2 border-b border-gray-400">
                            <img src={DigischoolLogo} alt="" />
                            {/* <img src={school_image} alt="" /> */}
                        </div>
                    </div>
                </div>
            </div>


            <div className="bg-gray-50">
                <div className="py-12 px-6 mx-auto max-w-6xl">
                    <div className="flex flex-col gap-5 md:flex-row">
                        {features.map((feature, index) => (
                            <div
                                key={index} // Make sure to add a unique key when mapping over an array
                                className="flex flex-col p-8 space-y-4 bg-white rounded-lg border border-gray-200 transition-shadow duration-500 ease-out cursor-pointer hover:shadow-xl"
                            >
                                <div className="flex items-center space-x-3">
                                    <div className="relative">
                                        <span
                                            className={`${feature.color} absolute top-0 left-4 w-3 h-3 rounded-full opacity-50`}
                                        />
                                        {feature.icon}
                                    </div>
                                    <div className="relative">
                                        <span
                                            className={`${feature.color} absolute right-0 bottom-1 w-12 h-1.5 opacity-60`}
                                        />
                                        <h2 className="relative text-xl font-display">{feature.title}</h2>
                                    </div>
                                </div>
                                <p className="text-sm leading-relaxed text-gray-500">{feature.description}</p>
                            </div>
                        ))}
                    </div>

                </div>
            </div>

            <div className=' bg-gray-400 py-11'>
                <div className='flex flex-col items-center space-y-4 md:flex-row justify-between px-6 mx-auto max-w-6xl font-semibold'>
                    <div className=' flex flex-row items-center text-white text-sm'>
                        &copy; {currentYear} Asapay Limited. All rights reserved.
                    </div>
                    <div className='flex flex-row items-center text-white text-sm space-x-2'>
                        <BsTelephoneInboundFill />
                        <p> +254 722 406 794</p>
                    </div>
                    <div className='flex flex-row items-center text-white text-sm space-x-2'>
                        <BsGoogle />
                        <p>digischoolke@gmail.com</p>
                    </div>
                </div>
            </div>

        </div>


    )
}

export default LandingPage